import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { fetchSchools } from "../redux/schoolSlice";
import StudentQuizDetails from "./StudentQuizDetails";

export default function SchoolSelect() {
  const dispatch = useDispatch();
  const { data: schools, loading } = useSelector((state) => state.schools);
  const [selectedSchool, setSelectedSchool] = useState(null);

  useEffect(() => {
    dispatch(fetchSchools());
  }, [dispatch]);

  const handleSelect = async (option) => {
    console.log("option", option);
    setSelectedSchool(option);
    localStorage.setItem("db_name", option.school.db_name);
  };

  const options = schools.map((school) => ({
    value: school.id,
    label: school.school_name,
    school: school,
  }));

  return (
    <div style={{ width: "100%" }}>
      <Select
        options={options}
        value={selectedSchool}
        onChange={handleSelect}
        placeholder="Select School"
        isClearable
      />
      {selectedSchool && <StudentQuizDetails selectedSchool={selectedSchool} />}
    </div>
  );
}
